export default "__VITE_ASSET__EXMg2iLO__"